module.exports = __webpack_public_path__ + "media/images/number_7_red-9f825a778a575191751feed861b509ef.png";